import { notification } from "antd";
import { ApolloError } from "apollo-client";
import { action, makeAutoObservable } from "mobx";
import { Api } from "../../common/Api";
import { stateCities, USstates } from "../../common/Data";
import { sleep } from "../../common/Utils";
import { communityStore } from "../community/CommunityStore";
import { Store } from "../Store";
import { OrgsStore } from "./OrgsStore";

export class OrgEditStore {
  orgsStore: OrgsStore;

  loading = false;
  uploading = false;
  saving = false;
  visible = false;
  model: any = {
    canFund: false,
    isSchool: false,
    divisionId: undefined,
    communityId: undefined,
    state: undefined,
    city: undefined,
    grades: [],
  };

  constructor(orgsStore: OrgsStore) {
    makeAutoObservable(this, {
      orgsStore: false,
    });
    this.orgsStore = orgsStore;
  }

  get divisions() {
    return Store.adminStore.divisionStore.divisions;
  }

  get communities() {
    const division = Store.adminStore.divisionStore.divisions.find((x) => x.id === this.model.divisionId);
    return division?.communities || [];
  }

  get cityList() {
    return (stateCities[this.model?.state] || []).sort();
  }

  states = Object.entries(USstates).map(([key, value]) => ({
    key,
    value,
  }));

  @action async edit(id?) {
    const community = communityStore.data;
    await Store.adminStore.divisionStore.refresh();
    if (id) {
      Api.org.getEditOrg(id).then((res) => {
        this.model = res.data.org;
      });
    } else {
      this.model = {
        canFund: false,
        isSchool: false,
        communityId: community.id,
        state: undefined,
        city: undefined,
        divisionId: community.divisionId,
        grades: [],
      };
    }
    this.visible = true;
  }

  @action save(values) {
    const { id, devisionId, communityId, logo } = this.model;
    Api.org
      .save({ id, devisionId, communityId, logo, ...values })
      .then(async (res) => {
        notification.success({ message: `Organization ${values.name} saved` });

        this.close();

        await sleep(3000);
        this.orgsStore.refresh();
      })
      .catch((err: ApolloError) => {});
  }

  @action close() {
    this.model = {};
    this.visible = false;
  }
}
